// extracted by mini-css-extract-plugin
export default {"wrapper":"TabBar_wrapper__TiqX9","border":"TabBar_border__g1xxo","container":"TabBar_container__tQB58","item":"TabBar_item__3BZzJ","selected":"TabBar_selected__j5QJV"};